// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../actions-list';
import {getDefaultState as getTransferDefaultState} from '../state';

const setRejectedTransferReason = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.payload
    });

export default (state = getTransferDefaultState().rejectedReason, action) => {

    const actionTypes = {
        [actions.SET_TRANSFER_REJECTED_REASON]: setRejectedTransferReason
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/transfers/reducers/rejected-reason.js